export function getText(value) {
  switch (value) {
    case 'my-boards': {
      return 'My Boards'
    }
    case 'other-boards': {
      return 'Boards'
    }
    case 'private': {
      return 'Private'
    }
    default:
  }
}
